var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1083_7067)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.802 2.16499L18.377 4.55399C18.857 4.75999 19.24 5.14299 19.447 5.62399L21.835 11.198C22.055 11.71 22.055 12.29 21.835 12.802L19.446 18.377C19.24 18.857 18.857 19.24 18.376 19.447L12.802 21.835C12.29 22.055 11.71 22.055 11.198 21.835L5.62298 19.446C5.14209 19.24 4.75894 18.8569 4.55298 18.376L2.16498 12.802C2.05637 12.5486 2.00037 12.2757 2.00037 12C2.00037 11.7243 2.05637 11.4514 2.16498 11.198L4.55398 5.62299C4.75998 5.14299 5.14298 4.75999 5.62398 4.55299L11.198 2.16499C11.4514 2.05638 11.7243 2.00038 12 2.00038C12.2757 2.00038 12.5485 2.05638 12.802 2.16499Z",
    stroke: "#828282",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16V16.01",
    stroke: "#828282",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 13C12.4498 13.0014 12.8868 12.8511 13.2407 12.5734C13.5945 12.2958 13.8444 11.907 13.95 11.4698C14.0557 11.0327 14.0109 10.5726 13.8229 10.1641C13.6349 9.75549 13.3147 9.42219 12.914 9.21801C12.5162 9.01422 12.0611 8.95103 11.6228 9.03873C11.1845 9.12642 10.7888 9.35984 10.5 9.70101",
    stroke: "#828282",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1083_7067"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.1b88f5ef445c2ef0da62892aa0f2dc84.svg";
export { ForwardRef as ReactComponent };